import React, { useEffect, useState, useMemo } from 'react';
import { FaBook } from 'react-icons/fa';
import Spinner from '../../components/ui/Spinner';
import { getAllBooks, getAllCategories } from '../../supabase/database';
import { getCategoryDiscountQuota } from '../../utils/categoryQuota';

const DaftarBuku = () => {
  const [books, setBooks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const [bookList, categoryList] = await Promise.all([
          getAllBooks(),
          getAllCategories(),
        ]);
        setBooks(bookList || []);
        setCategories(categoryList || []);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const categoryQuotaMap = useMemo(() => {
    const map = {};
    (categories || []).forEach(c => {
      if (c?.nama_kategori) {
        map[c.nama_kategori] = c.kuota_diskon ?? getCategoryDiscountQuota(c.nama_kategori) ?? 0;
      }
    });
    return map;
  }, [categories]);

  const filteredBooks = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return books;
    return (books || []).filter(b =>
      String(b.judul_buku || '').toLowerCase().includes(q) ||
      String(b.kode_buku || '').toLowerCase().includes(q) ||
      String(b.kategori || '').toLowerCase().includes(q)
    );
  }, [books, search]);

  if (loading) return <Spinner />;

  return (
    <div className="p-4 md:p-8 bg-white min-h-full">
      <div className="flex items-center gap-4 mb-6">
        <FaBook className="text-4xl text-amber-500" />
        <h1 className="text-3xl font-bold text-gray-800">Daftar Buku</h1>
      </div>

      <div className="bg-gray-50 p-4 rounded-lg shadow-sm mb-4">
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Cari judul/kode/kategori..."
          className="w-full p-2 border rounded-md"
        />
      </div>

      <div className="overflow-x-auto bg-white rounded-lg shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Kode</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Judul Buku</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Kategori</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Kuota Diskon</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredBooks.length > 0 ? filteredBooks.map(book => {
              const quota = categoryQuotaMap[book.kategori] ?? getCategoryDiscountQuota(book.kategori) ?? 0;
              return (
                <tr key={book.id || book.kode_buku}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-500">{book.kode_buku}</td>
                  <td className="px-6 py-4 text-sm font-medium text-gray-900">{book.judul_buku}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{book.kategori || '-'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{Number(quota) || 0}%</td>
                </tr>
              );
            }) : (
              <tr>
                <td colSpan="4" className="text-center p-6 text-gray-500">Tidak ada buku ditemukan.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DaftarBuku;

